import { useLocation, useNavigate } from "react-router-dom";

function ReservationPending() {
  const location = useLocation();
  const navigate = useNavigate();

  const email = location.state?.email;

  return (
    <div className="flex flex-col items-center justify-center h-screen text-center px-4">

      <h1 className="text-2xl font-semibold mb-4">
        Vérifiez votre email 📧
      </h1>

      <p className="text-gray-600 max-w-md">
        Nous vous avons envoyé un lien pour confirmer votre réservation.
        Ce lien expire dans 15 minutes.
      </p>

      {/* 🔥 Email affiché */}
      {email && (
        <p className="mt-3 text-sm text-gray-500">
          Email envoyé à <span className="font-medium">{email}</span>
        </p>
      )}

      {/* 🔥 Actions */}
      <div className="mt-6 flex flex-col gap-3">

        <button
          onClick={() => navigate("/")}
          className="px-5 py-2 rounded-lg bg-[#3A9D23] text-white hover:bg-[#33891E]"
        >
          Retour à l’accueil
        </button>


      </div>

    </div>
  );
}

export default ReservationPending;